import m from "../../geodata/es2015/continentsRussiaEuropeLow";
window.am4geodata_continentsRussiaEuropeLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/continentsRussiaEuropeLow.js
// module id = null
// module chunks = 